import axios from '../../../boot/axios';
import { buildFetchUrl } from "../../../helpers/url";

export default {
    
    betfairlogin(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/betfairlogin', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    betfairlogout(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/betfairlogout', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },   
    checkBetfairLogin(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/checkBetfairLogin', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },

    vendor_placeOrders(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/vendor_placeOrders', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },

    vendor_betfairCashout(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/vendor_betfairCashout', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },

    vendor_deleteOrder(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/vendor_deleteOrder', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },

    vendor_updateOrder(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/vendor_updateOrder', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
}